'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _InstagramOutlined = _interopRequireDefault(require('./lib/icons/InstagramOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _InstagramOutlined;
  exports.default = _default;
  module.exports = _default;